import { __decorate, __metadata } from 'tslib';
import { Service } from '../../decorators/class/service.js';
import { SurfaceService } from '../../services/surface/surface-service.js';

/**
 * 用于管理EditorProvider的服务，可通过此服务查看当前editor焦点下，provider是否可用。
 * @public
 */
let AdapterMatchService = class AdapterMatchService {
    constructor(surfaceService) {
        this.surfaceService = surfaceService;
    }
    /**
     * 查看一个 provider 当前是否可用，
     * 当 provider 是编辑器级别且当前焦点
     * 编辑器对应 provider 声明的 Adapter
     * provider 就是可用的。未注册视为不可用, 没声明编辑器列表视为可用。
     *
     * @param options - Provider
     */
    isAvailable(options, editor) {
        var _a;
        if (!options)
            return true;
        if (!options.adapters) {
            return true;
        }
        const currentSurface = this.surfaceService.info.current;
        let surfaceId = currentSurface === null || currentSurface === void 0 ? void 0 : currentSurface.id;
        if (editor) {
            surfaceId = this.surfaceService.getSurfaceId(editor);
        }
        if (!currentSurface)
            return false;
        const currentAdapter = this.surfaceService.getAdapter(surfaceId);
        if ((_a = options.adapters) === null || _a === void 0 ? void 0 : _a.some(adapter => currentAdapter && currentAdapter.toString() === adapter)) {
            return true;
        }
        return false;
    }
    matchOpenedEditors(options) {
        if (!(options === null || options === void 0 ? void 0 : options.adapters))
            return [];
        return this.surfaceService.editors
            .filter(info => options.adapters.includes(info.adapter.toString()))
            .map(info => info.editor);
    }
};
AdapterMatchService = __decorate([
    Service({ overridable: true }),
    __metadata("design:paramtypes", [SurfaceService])
], AdapterMatchService);

export { AdapterMatchService };
//# sourceMappingURL=adapter-match-service.js.map
